var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgCloseX(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "#FD0059",
    strokeWidth: 3,
    d: "M19.75 12.121L16.127 16l3.752 3.751-3.88-3.623-3.75 3.751 3.622-3.88-3.75-3.748L16 15.87l3.75-3.75z"
  }));
}

export default SvgCloseX;